import React from "react";
import { CreateOutputConfig } from "./OutputConfigList/CreateOutputConfig.Logic";
import { OutputConfigList } from "./OutputConfigList/OutputConfigList.Logic";

export const OutputConfigLandingPageView: React.FC = () => {
  return (
    <>
      <CreateOutputConfig />
      <OutputConfigList />
    </>
  );
};
